import { apiClient } from './api';
import { API_ENDPOINTS, APIHeadersWithAuth } from '../globalConstants';

export interface TaskInput {
  title: string;
  description?: string;
  customerId?: number;
  customerName?: string;
  serviceId?: number;
  saleId?: number;
  items?: any[];
  specs?: {
    size?: string;
    materialId?: number | string;
    materialName?: string;
    materials?: { materialId: number | string; materialName?: string; consumedUnits?: number }[];
    quantity?: number;
    finishing?: string[];
    /** Agency / OEM outsourced fields */
    isAgency?: boolean;
    isOutsourced?: boolean;
    vendorId?: number | string;
    vendorCost?: number;
  };
  priority?: string;
  dueDate?: string;
  driveUrl?: string;
  notes?: string;
}

export async function listTasks(shopId: number | string, stage?: string): Promise<any[]> {
  const res = await apiClient.get<{ data: any[] }>(
    API_ENDPOINTS.tasks.LIST(shopId, stage),
    { headers: APIHeadersWithAuth() }
  );
  return res.data;
}

export async function createTask(
  shopId: number | string,
  input: TaskInput,
  opts: { silentToast?: boolean } = {}
): Promise<any> {
  const res = await apiClient.post<{ data: any }>(
    API_ENDPOINTS.tasks.CREATE(shopId),
    input,
    {
      headers: APIHeadersWithAuth(),
      ...(opts.silentToast ? { __silentToast: true } : {}),
    } as RequestInit
  );
  return res.data;
}

export async function updateTask(
  shopId: number | string,
  id: number | string,
  input: Partial<TaskInput>
): Promise<any> {
  const res = await apiClient.put<{ data: any }>(
    API_ENDPOINTS.tasks.UPDATE(shopId, id),
    input,
    { headers: APIHeadersWithAuth() }
  );
  return res.data;
}

export async function addTaskNote(
  shopId: number | string,
  id: number | string,
  input: { note: string; driveUrl?: string }
): Promise<any> {
  const res = await apiClient.post<{ data: any }>(
    API_ENDPOINTS.tasks.NOTES(shopId, id),
    input,
    { headers: APIHeadersWithAuth() }
  );
  return res.data;
}

export async function logTaskHours(
  shopId: number | string,
  id: number | string,
  input: { team: string; hours: number; note?: string }
): Promise<any> {
  const res = await apiClient.post<{ data: any }>(
    API_ENDPOINTS.tasks.HOURS(shopId, id),
    input,
    { headers: APIHeadersWithAuth() }
  );
  return res.data;
}

export async function transitionTask(
  shopId: number | string,
  id: number | string,
  input: { toStage: string; note?: string; driveUrl?: string; hours?: number },
  opts: { silentToast?: boolean } = {}
): Promise<any> {
  const res = await apiClient.post<{ data: any }>(
    API_ENDPOINTS.tasks.TRANSITION(shopId, id),
    input,
    {
      headers: APIHeadersWithAuth(),
      ...(opts.silentToast ? { __silentToast: true } : {}),
    } as RequestInit
  );
  return res.data;
}

export async function fetchTimeline(shopId: number | string, id: number | string): Promise<any[]> {
  const res = await apiClient.get<{ data: any[] }>(
    API_ENDPOINTS.tasks.TIMELINE(shopId, id),
    { headers: APIHeadersWithAuth() }
  );
  return res.data;
}

export async function fetchTaskSummary(shopId: number | string): Promise<any> {
  const res = await apiClient.get<{ data: any }>(
    API_ENDPOINTS.tasks.SUMMARY(shopId),
    { headers: APIHeadersWithAuth() }
  );
  return res.data;
}
